
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement(
		"g",
		{ fill: "#42ade2" },
		React.createElement("path", { d: "m59.8 24.3c0 0 1.1-6.2-3.5-3.4 0 0-.4-6.3-4.3-1.9 0 0-2.1-3.9-4.4-.3-3.1 4.8-5.2 12.4-3.2 25l3.8-2.5c2.7-7.9 12.4-8.8 13.7-13.1.9-3-2.1-3.8-2.1-3.8" }),
		React.createElement("path", { d: "m22.1 17.6l-9.9 3.6c2.2-12 16.6-11.2 16.6-11.2s-6.8 3.2-6.7 7.6" }),
		React.createElement("path", { d: "m23.7 19.8l-10.5 1.4c4.8-11.2 18.7-7.3 18.7-7.3s-7.3 1.6-8.2 5.9" })
	),
	React.createElement(
		"g",
		{ fill: "#ffd93b" },
		React.createElement("path", { d: "m2 29l5.4-1.4v3.6c0-.1-3.3-.6-5.4-2.2" }),
		React.createElement("path", { d: "M7.4,27.5L2,24.8c3.6-2.8,7.7-1.9,7.7-1.9L7.4,27.5z" })
	),
	React.createElement(
		"g",
		{ fill: "#e08828" },
		React.createElement("path", { d: "m33.8 53h-2.1v7.9c-.3.1-2.1-.1-2.9-.1-1.8 0-3.3 1.3-3.3 1.3h8.3v-9.1" }),
		React.createElement("path", { d: "m25 53h-2.1v7.9c-.3.1-2.1-.1-2.9-.1-1.8 0-3.3 1.3-3.3 1.3h8.3v-9.1" })
	),
	React.createElement("path", { d: "m54 36.2c3.9 0-4.1 17.5-23.3 17.5-13 0-23.9-5.2-23.9-21.5 0-10.1 6.4-18.3 19.5-15 13.3 3.5 6.5 19 27.7 19", fill: "#42ade2" }),
	React.createElement("path", { d: "m37.6 51.7c-15.6 0-14-12-27.9-11.2 5.1 15.8 27.9 11.2 27.9 11.2", fill: "#fff" }),
	React.createElement("path", { d: "m39.1 29.2c-10-9.8-20.2 6.2-7.9 12.6 12.1 6.2 20.4-4.8 20.4-4.8s-6.1-1.5-12.5-7.8", fill: "#297b9d" }),
	React.createElement("circle", { cx: "15.1", cy: "24.9", fill: "#3e4347", r: "2.5" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/bird.js
// module id = 683
// module chunks = 0